var Handlebars = require("C:\\Users\\surunzi\\project\\eruda-dom\\node_modules\\handlebars\\runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<ul class=\"eruda-dom-tree\"></ul>\r\n<div class=\"eruda-inspect\">Inspect Selected Element</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/template.hbs
// module id = 120
// module chunks = 0